module.exports = __webpack_public_path__ + "img/梯田.3b86b1ae.jpg";